import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';

class FieldTextArea extends React.Component {

  render() {

    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const value = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;
    
    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={key} />
          <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
          { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
          <FormControl
            type="text"
            placeholder={field.label_name}
            as="textarea"
            rows={3}
            value={value}
            readOnly={!editable}
            className={`mr-sm-2 ${error ? 'error-w' : ''}`}
            onChange={event => this.props.onValueChange(key, event.target.value)} />
        </div>
      </div>
    );
  }
}
export default FieldTextArea;